import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { App } from '@df/core/app';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { ImageModule } from '@df/module-image/image.module';
import { TrustpilotWidgetComponent } from '@df/module-trustpilot/trustpilot-widget.component';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { NewsletterFormComponent } from '../../../newsletter/newsletter-form.component';
import { BottomPanelAreaDirective } from '../../../ui/display/bottom-panel/bottom-panel-area.directive';
import { PAGE_FOOTER_BLOCK_CONFIG } from './page-footer.config';
export interface IPageFooterBlockData extends Catalog.IBlockData<IPageFooterBlockContent> {}

export interface IPageFooterBlockData extends Catalog.IBlockData<IPageFooterBlockContent> {}

declare global {
    interface Window {
        __tcfapi: (string, number, method: () => void) => void;
    }
}

export interface IPageFooterBlockContent {
    columns: IPageFooterColumn[];
    newsletter_heading: string;
    newsletter_copy: string;
    contact_us_link: string;
    find_store_link: string;
    phone_number: string;
    links: IPageFooterBottomLinks[];
    payment_method_icons: IPageFooterPaymentIcon[];
    social_icons: IPageFooterSocialIcon[];
}

export interface IPageFooterBottomLinks {
    text: string;
    link?: string;
    open_cookies_modal?: boolean;
    label_only_on_mobile?: boolean;
}

export interface IPageFooterColumn {
    heading: true;
    links: IPageFooterLink[];
}
export interface IPageFooterLink {
    icon?: string;
    label: string;
    link: string;
    label_only_on_mobile?: boolean;
    open_cookies_modal?: boolean;
}
export interface IPageFooterPaymentIcon {
    image: string;
    icon?: string;
}

export interface IPageFooterSocialIcon {
    image: string;
    image_desktop?: string;
    link: string;
    name: string;
}
@Component({
    selector: 'page-footer',
    templateUrl: 'page-footer.html',
    styleUrls: ['./page-footer.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        SizeClassDirective,
        NewsletterFormComponent,
        TrustpilotWidgetComponent,
        HrefComponent,
        ICmsClientModule,
        ImageModule,
        RouterLink,
        ZippyModule,
        IfSizeDirective,
        SizeClassDirective,
        BottomPanelAreaDirective
    ]
})
@ICmsComponent<PageFooterComponent>(PAGE_FOOTER_BLOCK_CONFIG)
export class PageFooterComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: IPageFooterBlockContent;

    app = inject(App);

    get currentYear() {
        return new Date().getFullYear();
    }

    manageCookies() {
        if (this.app?.isPlatformBrowser) {
            window?.__tcfapi?.('displayConsentUi', 2, () => {});
        }
    }
}
